import React from 'react';

const EmailInput = ({ 
  name, 
  type, 
  onChange,
  placeholder,
  value,
  register,
  check = true,
  info_type
}) => {
  return (
    <>
      <input 
        name={name}
        type={type}
        id={name}
        placeholder={placeholder}
        onChange={onChange && ((event) => onChange(event, name, info_type))}
        value={value}
        ref={register}
        disabled={!check ? "disabled" : ""}
      />
    </>
  )
}

export default EmailInput;